import React, { useState, useEffect, useContext } from 'react';
// import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './ShipmentSelectScanType.css'
import CustomDropdown from '../common/CustomDropdown';
import { UserContext } from '../common/UserContext';

function ShipmentSelectScanType() {
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
    const navigate = useNavigate();
    const [navigateTo, setNavigateTo] = useState('');
    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);

        sessionStorage.setItem('selectedScpId', selectedScpId);

    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);
    const handleShipmentInward = () => {
        setNavigateTo(`/ShipInScanPendingList`);

    };
    // const handleRackManagement = () => {
    //     setNavigateTo(`/RackmanagementMaster`)
    // }
    // const handleBatchMaster = () => {
    //     setNavigateTo(`/WareHouseBatchMaster`)
    // }
    // const handleProductMaster = () => {
    //     setNavigateTo(`/WareHouseProductMaster`)
    // }
    // const handleTemplateMaster = () => {
    //     setNavigateTo(`/dashboard/Template`)
    // }
    // const GlobalCompanyMaster = () => {
    //     setNavigateTo(`/dashboard/GlobalCompanyMaster`)
    // }
    // const handleBatchMaster = () => {
    //     setNavigateTo(`/dashboard/BatchMaster`)
    //}
    const handleShipmentOutward = (shipmentId) => {
        // setNavigateTo(`/ShipOutScanSearch/${UM_GroupId}/${UM_CompanyID}/${UM_CompanyGrpID}/${UM_UserId}/${UM_UserCode}/${selectedScpId}/ShipOutScanSearch`);
        setNavigateTo(`/ShipOutScanPendingList`);
    };
    useEffect(() => {
        if (navigateTo) {
            navigate(navigateTo);
        }
    }, [navigate, navigateTo]);

    const handleDropdownChange = (event) => {
        const value = event.target.value;
        if (value === 1) {
            handleShipmentInward();
        } else if (value === 2) {
            handleShipmentOutward();
        }
    };

    const shipmentOptions = [
        { id: 1, name: 'SHIPMENT INWARD' },
        { id: 2, name: 'SHIPMENT OUTWARD' }
    ];
    return (
        <div className='main_container'>
            <div className='row'>
                <div className='col-md-12'>
                    <h4 className=' formHeading mt-2 '>Shipment Scanning</h4>
                    <div className=' container-for-shipment-main mt-4'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <label className='form-label'>Shipment Type</label>
                                <div className='select-container'>
                                    <CustomDropdown
                                        options={shipmentOptions}
                                        value=""
                                        onChange={handleDropdownChange}
                                        name="shipmentType"
                                        placeholder="--Select--"
                                        idKey="id"
                                        displayKey="name"
                                    />
                                </div>                                                               
                            </div>
                             {/* <div className='col-md-6'>
                            <label className='form-label'></label>
                            <div className='select-container'>
                            <button className='btn btn-secondary' onClick={GlobalCompanyMaster}>Global Company Master</button>
                            </div>
                        </div>  */}
                             {/* <div className='col-md-6'>
                                <label className='form-label'></label>
                                <div className='select-container'>
                                   <button className='btn btn-secondary' onClick={handleTemplateMaster}>Template Master</button>
                                </div>
                            </div> */}
                        </div>
                        {/* <div className='col-md-6'>
                                <label className='form-label'></label>
                                <div className='select-container'>
                                   <button className='btn btn-secondary' onClick={handleBatchMaster}>Batch Master</button>
                                </div>
                            </div> */}
                       
                       
                       
                    </div>
                </div>
            </div>
           
              
        </div>
        
    );
}

export default ShipmentSelectScanType;




// import React, { useState, useEffect, useContext } from 'react';
// import { useParams } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
// import './ShipmentSelectScanType.css'
// import CustomDropdown from '../common/CustomDropdown';
// import { UserContext } from '../common/UserContext';

// function ShipmentSelectScanType() {
//     const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
//     const navigate = useNavigate();
//     const [navigateTo, setNavigateTo] = useState('');
//     useEffect(() => {
//         sessionStorage.setItem('UM_GroupId', UM_GroupId);
//         sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
//         sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
//         sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
//         sessionStorage.setItem('UM_UserId', UM_UserId);
//         sessionStorage.setItem('UM_UserCode', UM_UserCode);

//         sessionStorage.setItem('selectedScpId', selectedScpId);

//     }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);
//     const handleShipmentInward = () => {
//         setNavigateTo(`/ShipInScanPendingList`);

//     };
//     // const handleRackManagement = () => {
//     //     setNavigateTo(`/RackmanagementMaster`)
//     // }
//     // const handleBatchMaster = () => {
//     //     setNavigateTo(`/WareHouseBatchMaster`)
//     // }
//     // const handleProductMaster = () => {
//     //     setNavigateTo(`/WareHouseProductMaster`)
//     // }
//     const handleTemplateMaster = () => {
//         setNavigateTo(`/dashboard/Template`)
//     }
//     const GlobalCompanyMaster = () => {
//         setNavigateTo(`/dashboard/GlobalCompanyMaster`)
//     }
//     const handleBatchMaster = () => {
//         setNavigateTo(`/dashboard/BatchMaster`)
//     }
//     const handleShipmentOutward = (shipmentId) => {
//         // setNavigateTo(`/ShipOutScanSearch/${UM_GroupId}/${UM_CompanyID}/${UM_CompanyGrpID}/${UM_UserId}/${UM_UserCode}/${selectedScpId}/ShipOutScanSearch`);
//         setNavigateTo(`/ShipOutScanPendingList`);
//     };
//     useEffect(() => {
//         if (navigateTo) {
//             navigate(navigateTo);
//         }
//     }, [navigate, navigateTo]);

//     const handleDropdownChange = (event) => {
//         const value = event.target.value;
//         if (value === 1) {
//             handleShipmentInward();
//         } else if (value === 2) {
//             handleShipmentOutward();
//         }
//     };

//     const shipmentOptions = [
//         { id: 1, name: 'SHIPMENT INWARD' },
//         { id: 2, name: 'SHIPMENT OUTWARD' }
//     ];
//     return (
//         <div className='main_container'>
//             <div className='row'>
//                 <div className='col-md-12'>
//                     <h4 className=' formHeading mt-2 '>Shipment Scanning</h4>
//                     <div className=' container-for-shipment-main mt-4'>
//                         <div className='row'>
//                             <div className='col-md-6'>
//                                 <label className='form-label'>Shipment Type</label>
//                                 <div className='select-container'>
//                                     <CustomDropdown
//                                         options={shipmentOptions}
//                                         value=""
//                                         onChange={handleDropdownChange}
//                                         name="shipmentType"
//                                         placeholder="--Select--"
//                                         idKey="id"
//                                         displayKey="name"
//                                     />
//                                 </div>                                                               
//                             </div>
//                              <div className='col-md-6'>
//                             <label className='form-label'></label>
//                             <div className='select-container'>
//                             {/* <button className='btn btn-secondary' onClick={GlobalCompanyMaster}>Global Company Master</button> */}
//                             </div>
//                         </div> 
//                              {/* <div className='col-md-6'>
//                                 <label className='form-label'></label>
//                                 <div className='select-container'>
//                                    <button className='btn btn-secondary' onClick={handleTemplateMaster}>Template Master</button>
//                                 </div>
//                             </div> */}
//                         </div>
//                         {/* <div className='col-md-6'>
//                                 <label className='form-label'></label>
//                                 <div className='select-container'>
//                                    <button className='btn btn-secondary' onClick={handleBatchMaster}>Batch Master</button>
//                                 </div>
//                             </div> */}
                       
                       
                       
//                     </div>
//                 </div>
//             </div>
           
              
//         </div>
        
//     );
// }

// export default ShipmentSelectScanType;
